module.exports = __webpack_public_path__ + "static/media/c.14bfb49f.svg";